import type { ReactElement } from 'react'

/** Under a table: how many of the matching rows are loaded, e.g. "Showing 50 of 589 calls". */
export function TableCountFooter({
  shown,
  total,
  noun,
  plural = `${noun}s`,
}: {
  shown: number
  total: number
  /** Singular, for a total of one. */
  noun: string
  /** Defaults to the noun with an "s". */
  plural?: string
}): ReactElement | null {
  if (!total) return null
  return (
    <p className="shrink-0 pt-3 text-body-xs tabular-nums text-subtle">
      Showing {shown.toLocaleString(`en-US`)} of {total.toLocaleString(`en-US`)} {total === 1 ? noun : plural}
    </p>
  )
}
